<div class="tags-input-wrapper">
  <label *ngIf="label" class="tags-input-label">
    {{ label }}
    <span *ngIf="required" class="text-danger">*</span>
  </label>

  <div
    class="bootstrap-tagsinput"
    [class.focus]="focused"
    [class.disabled]="disabled"
    (click)="onContainerClick()"
  >
    <span *ngFor="let tag of tags; let i = index" class="tag label label-info">
      {{ tag }}
      <span
        *ngIf="!disabled"
        class="tag-remove"
        (click)="removeTag(i)"
        role="button"
        tabindex="0"
      >
        ×
      </span>
    </span>

    <app-input-text
      [bare]="true"
      [plain]="true"
      cssClass="tags-input-field"
      [placeholder]="tags.length === 0 ? placeholder : ''"
      [isDisabled]="disabled"
      [value]="inputValue"
      autocomplete="off"
      (inputEvent)="onInputChange($event)"
      (keydownEvent)="onInputKeyDown($event)"
      (blurEvent)="onInputBlur($any($event))"
      (focusEvent)="onInputFocus()"
    ></app-input-text>
  </div>

  <div class="tags-input-hint" *ngIf="!disabled">
    <small class="text-muted">
      {{ 'admin.store.events.musicStyleHint' | translate }} {{ tags.length }}/{{
        maxTags
      }}
      tags
    </small>
  </div>
</div>
